// @flow
import React from 'react';
import styled from '@emotion/styled';

import FantasyInsiderBanner from '../images/FantasyInsider.gif';

const Wrapper = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
  paddingBottom: theme.spacing.small
}));

const Img = styled.img({
  maxWidth: '100%'
});

const Logo = () => (
  <Wrapper>
    <Img src={FantasyInsiderBanner} alt="Fantasy Insider" />
  </Wrapper>
);

export default Logo;
